document.addEventListener('DOMContentLoaded', function () {
  // Fragrance + Discover accordions: only one <details> open at a time per product
  document
    .querySelectorAll('.fragrance-accordion, .discover-accordion')
    .forEach(function (group) {
      var items = group.querySelectorAll('details');

      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;

          items.forEach(function (other) {
            if (other !== item) other.open = false;
          });
        });
      });
    });

  // Basic "Add to bag" forms post to /cart/add and redirect to cart.
  document.querySelectorAll('.cart-form').forEach(function (form) {
    form.addEventListener('submit', function () {
      var btn = form.querySelector('[type="submit"]');
      if (btn) {
        btn.dataset.originalText = btn.textContent;
        btn.textContent = 'Adding…';
        btn.disabled = true;
      }
    });
  });
});